import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'avano-divider',
  templateUrl: './avano-divider.component.html',
  styleUrls: ['./avano-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvanoDividerComponent {
  @Input() styleClass: string;

  @Input() style: any = '';

  @Input() layout = 'horizontal';

  containerClass() {
    return {
      'a-divider-horizontal': this.layout === 'horizontal',
      'a-divider-vertical': this.layout === 'vertical'
    };
  }
}
